export const types = {
	LOAD_REQUEST: 'SingleCustomFinancialStatement/LOAD_REQUEST',
	LOAD_SUCCESS: 'SingleCustomFinancialStatement/LOAD_SUCCESS',
	LOAD_FAILED: 'SingleCustomFinancialStatement/LOAD_FAILED',
	SET_FINANCIAL_DATA: 'SingleCustomFinancialStatement/SET_FINANCIAL_DATA',
};

const initialState = {
	financialData: [],
	loading: false,
	error: null,
};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case types.LOAD_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};

		case types.LOAD_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};

		case types.LOAD_FAILED:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case types.SET_FINANCIAL_DATA:
			return {
				...state,
				financialData: action.data,
			};

		default:
			return state;
	}
}

export const actions = {
	loadSingleCustomFinancialStatementRequest: stock_code => {
		return {
			type: types.LOAD_REQUEST,
			stock_code,
		};
	},
	loadSingleCustomFinancialStatementCompleted: data => {
		return {
			type: types.LOAD_SUCCESS,
			data,
		};
	},
	loadSingleCustomFinancialStatementFailed: error => {
		return {
			type: types.LOAD_FAILED,
			error,
		};
	},
	setFinancialData: data => {
		return {
			type: types.SET_FINANCIAL_DATA,
			data,
		};
	},
};
